import { VesselFrontIcon } from '~components/icons'
import { Alert, Select } from '~components/web-components'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetScope } from '~hooks/permissions/use-has-scope'
import {
  GetVesselsResItem,
  useGetVessels,
} from '~hooks/queries/vessels/use-get-vessels'
import CircularProgress from '@mui/material/CircularProgress'

export function VesselsSelect() {
  const { vessel } = useParams<string>()
  const { data, isLoading, isError } = useGetVessels()
  const navigate = useNavigate()
  const scope = useGetScope()

  function onChangeHandler(e: any, optionValue: string) {
    // Don't navigate if optionValue is empty or same as current vessel
    if (!optionValue || optionValue === vessel) {
      return
    }
    navigate(
      `/financials/technical-management/${optionValue}/bunker-adjustment`,
    )
  }

  if (isLoading) return <CircularProgress aria-label="Loading…" />
  if (isError || !data)
    return (
      <Alert severity="error">
        Oops! There was an error getting the vessels. Please reload the page or
        try again later.
      </Alert>
    )

  if (data.length === 0) {
    return (
      <Alert severity="info">
        Unfortunately, there are no vessels available.
      </Alert>
    )
  }

  const technicalVessls = data.filter((vessel) => {
    return (
      scope.includes(`vessel:${vessel.vesselCode}:technical`) ||
      scope.includes(`vessel:${vessel.vesselId}:technical`)
    )
  })

  return (
    <Select
      label="vessels"
      name="period-select"
      onChange={onChangeHandler}
      options={makeValuePairs(technicalVessls || [])}
      icon={<VesselFrontIcon />}
      value={vessel}
      placeholder="Choose vessel"
    />
  )
}

function makeValuePairs(data: GetVesselsResItem[]) {
  return data.map((item) => {
    const tramosCode = constructTramosCode(item.vesselCode)
    return {
      label: `${item.poolPartner}: ${item.vesselName} - ${tramosCode} - ${item.pool}`,
      value: tramosCode,
    }
  })
}

export function constructTramosCode(vesselCode: string) {
  // vessel code is a tramos code with a V in front of it
  if (vesselCode?.startsWith('V')) {
    return vesselCode.slice(1)
  }
  return vesselCode
}
